import React, { useMemo } from "react";
import styles from "./TestimonialsSection.module.css";
import TestimonialGallery from "./TestimonialGallery";
import StructuredData from "../components/StructuredData";
import { useTranslation } from "react-i18next";

const TestimonialsSection = ({ badgeKey = null, compact = false }) => {
  const { t } = useTranslation();
  const badge = badgeKey ? t(badgeKey) : null;

  const name = "Kevin Fontaine";
  const role = t("KFontaineTitle");
  const text = t("KFontaineTestimonial");
  const avatar = "/images/KFontaine.jpg";

  const reviewsSchema = useMemo(() => ({
    "@context": "https://schema.org",
    "@graph": [
      {
        "@type": "Review",
        itemReviewed: { "@type": "SoftwareApplication", name: "UpReality" },
        author: { "@type": "Person", name },
        reviewBody: text,
      },
    ],
  }), [text]);

  const quote = text.trim().replace(/^«\s*|\s*»$/g, "");

  return (
    <>
      <StructuredData id="testimonials-reviews" data={reviewsSchema} />
      <section className={`${styles.testimonialsSection}${compact ? ` ${styles.testimonialsSectionCompact}` : ""}`}>
        <div
          className={`${styles.testimonialsInner}${compact ? ` ${styles.testimonialsInnerCompact}` : ""}`}
        >
          <TestimonialGallery compact={compact} />
          <div className={`${styles.copy}${compact ? ` ${styles.copyCompact}` : ""}`}>
            <h2 className={`${styles.title}${compact ? ` ${styles.titleCompact}` : ""}`}>
              {t("TestimonialsTitle")}
            </h2>
            <blockquote className={`${styles.quote}${compact ? ` ${styles.quoteCompact}` : ""}`}>
              « {quote} »
            </blockquote>
            <div className={`${styles.author}${compact ? ` ${styles.authorCompact}` : ""}`}>
              <img
                src={avatar}
                className={`${styles.authorAvatar}${compact ? ` ${styles.authorAvatarCompact}` : ""}`}
                alt={name}
              />
              <p className={styles.authorMeta}>
                <span className={styles.authorName}>{name}</span>
                <br />
                {role}
              </p>
            </div>
            {badge ? (
              <p className={`${styles.testimonialBadge}${compact ? ` ${styles.testimonialBadgeCompact}` : ""}`}>
                {badge}
              </p>
            ) : null}
          </div>
        </div>
      </section>
    </>
  );
};

export default TestimonialsSection;
